// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__S14pf","inverted":"Button_inverted__aZwk0"};